/* src/app/main/matching/create/create-matching-batch.component.scss */
.custom-file-label {
  padding: 0.5em;
  font-size: 1em;
  display: inline-block;
  color: black;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
}
.custom-file-label:focus {
  outline-color: #006f8a;
  outline-offset: -1px;
  outline-width: 1px;
  outline-style: solid;
}
custom-file-label:-webkit-autofill,
custom-file-label:-webkit-autofill:hover,
custom-file-label:-webkit-autofill:focus,
custom-file-label:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
  -webkit-text-fill-color: black !important;
}
custom-file-label:-moz-autofill {
  background-color: white !important;
  color: black !important;
}
custom-file-label:-ms-input-placeholder {
  background-color: white !important;
  color: black !important;
}
.custom-file-input {
  display: none;
}
button.button:disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.7;
  border-color: rgba(0, 0, 0, 0.2);
}
/*# sourceMappingURL=create-matching-batch.component-NYV474C6.css.map */
